import { GestorServicesResponseDto } from '@app/data/dtos/tpv/gestor.dto';
import { PaymentsSessionCompany } from '@app/domain/models/payments-companies/payments-route-company';
import { resolvePaymentsCompanyId } from '@app/domain/models/payments-companies/payments-company-id';

/**
 * Filas PAYMENTS de `GET /api/gestor/services/` ⇒ comercios con valor de RUTA.
 * `payments_company.id_company` se usa TAL CUAL (banca ya aplicó `id_de_ruta`); si
 * faltara, la regla `resolvePaymentsCompanyId` (org_company_id → external_ref). Sin
 * ninguno, la fila no aporta comercio. Un mismo comercio en dos filas cuenta UNA vez.
 */
export function mapPaymentsSessionCompanies(dto: GestorServicesResponseDto | null | undefined): PaymentsSessionCompany[] {
  const vistos = new Map<string, PaymentsSessionCompany>();
  for (const fila of dto?.services ?? []) {
    if ((fila?.service ?? '').toString().trim().toUpperCase() !== 'PAYMENTS') continue;
    const pc = fila.payments_company;
    if (!pc) continue;
    const directo = pc.id_company;
    const routeId =
      typeof directo === 'number' && Number.isInteger(directo) && directo >= 0
        ? directo
        : typeof directo === 'string' && directo.trim() !== ''
          ? directo.trim()
          : resolvePaymentsCompanyId({ orgCompanyId: pc.org_company_id, externalRef: pc.external_ref });
    if (routeId === null) continue;
    const llave = String(routeId);
    if (!vistos.has(llave)) {
      vistos.set(llave, { routeId, name: typeof pc.name === 'string' ? pc.name : null });
    }
  }
  return [...vistos.values()];
}
